export default __webpack_public_path__ + "static/media/close-modal.5b1ac573.svg";